import { type AlwaysFilter, booleanFilterTypes } from '../../../../../../schemas/query/filterTypes.ts'
import { NotImplementedError } from '../../../../../errors.ts'
import { booleanEqualFilter, nullFilter } from './filters.ts'
import { validateFilterType } from './validateFilterType.ts'

export const generateBooleanFilter = (filter: AlwaysFilter): string => {
  const type = validateFilterType(filter.filter_type, booleanFilterTypes)

  switch (type) {
    case 'null': {
      return nullFilter(filter, false)
    }
    case 'not_null': {
      return nullFilter(filter, true)
    }
    case 'equal': {
      return booleanEqualFilter(filter, false)
    }
    case 'not_equal': {
      return booleanEqualFilter(filter, true)
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    default: {
      // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
      const x: never = type
      throw new NotImplementedError()
    }
  }
}
